export const SET_EDIT_ITEM = 'SET_EDIT_ITEM'
export const SET_INPUT = 'SET_INPUT'

export const RETRIEVING_TIMESLOTS = 'RETRIEVING_TIMESLOTS'
export const SET_RETRIEVED_TIMESLOTS = 'SET_RETRIEVED_TIMESLOTS'

export const SET_RETRIEVED_TIMESLOT = 'SET_RETRIEVED_TIMESLOT'
export const UPDATE_RETRIEVED_TIMESLOT = 'UPDATE_RETRIEVED_TIMESLOT'
export const DELETE_RETRIEVED_TIMESLOT = 'DELETE_RETRIEVED_TIMESLOT'

export const SET_SELECTED_TIMESLOT = 'SET_SELECTED_TIMESLOT'
export const UPDATE_SELECTED_TIMESLOT = 'UPDATE_SELECTED_TIMESLOT'

export const DELETE_SELECTED_TIMESLOT = 'DELETE_SELECTED_TIMESLOT'
export const DELETE_SELECTED_TIMESLOTS = 'DELETE_SELECTED_TIMESLOTS'

export const IS_HYDRATING_DATA = 'IS_HYDRATING_DATA'

export const SET_RESERVATION_TYPE = 'SET_RESERVATION_TYPE'
export const SET_PRODUCT_ZONE = 'SET_PRODUCT_ZONE'
export const SET_PRODUCT_LOCATION = 'SET_PRODUCT_LOCATION'
export const SET_PRODUCT_LOCATION_ID = 'SET_PRODUCT_LOCATION_ID'
export const SET_PRODUCT_GROUP_TITLE = 'SET_PRODUCT_GROUP_TITLE'
export const SET_EDIT_ROUTE = 'SET_EDIT_ROUTE'
export const SET_CART_ITEM_TYPE = 'SET_CART_ITEM_TYPE'
